import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";
import FragmentDataType from "../enums/fragment-data-type";
import { FragmentMessages } from "../../common/fragment-messages";
import FootballState from "../state/football-state";

export default class FieldGoalMissed extends Fragment {
    constructor(kickedTo) {
        super();
        this.code = "M";
        this.kickedTo = kickedTo;

        this.requiredData = [
            {
                name: "kickedTo",
                type: FragmentDataType.FieldPosition,
                displayName: "Kicked To",
                title: "Kicked To",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                showEndZoneYards: (gameConfig) =>
                    gameConfig.general.includeEndZoneYardage
            }
        ];
    }

    summarize(summaryContext, stringifier, play) {
        return new FragmentSummary(
            ` for ${stringifier.gain(
                summaryContext,
                summaryContext.fieldPosition,
                this.kickedTo,
                false
            )}${play.historyContains(FootballState.PatTry) ? "" : " missed"}`
        );
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
        summaryContext.fieldPosition = this.kickedTo;
        summaryContext.homeTeamHasPossession =
            !summaryContext.homeTeamHasPossession;
    }

    getFragmentTeamId() {
        return this.kickedBy?.teamId;
    }

    toJSON() {
        return {
            ...super.toJSON()
        };
    }
}
